/* KOKKZ — theme.js
   Rotations, carrousels, tiroirs (<dialog>), panier AJAX Shopify, sélecteur de variantes, popup. */
(() => {
  'use strict';

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const config = window.KOKKZ || { routes: { root: '/' }, strings: {}, cartType: 'drawer', freeShipping: 0 };
  const strings = config.strings || {};
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = (config.routes.root || '/').replace(/\/?$/, '/');

  const store = {
    get(key, fallback) {
      try { const raw = localStorage.getItem(key); return raw ? JSON.parse(raw) : fallback; }
      catch { return fallback; }
    },
    set(key, value) {
      try { localStorage.setItem(key, JSON.stringify(value)); } catch { /* stockage indisponible */ }
    },
  };

  const esc = (value) => String(value ?? '').replace(/[&<>"']/g, (c) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
  })[c]);

  let currency = 'EUR';
  const money = (cents) => new Intl.NumberFormat(config.locale || 'fr', { style: 'currency', currency })
    .format((Number(cents) || 0) / 100);

  /* ---------- Toast ---------- */
  const toast = $('[data-toast]');
  let toastTimer;
  function showToast(message) {
    if (!toast || !message) return;
    toast.textContent = message;
    toast.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-on'), 3200);
  }

  /* ---------- Rotations ---------- */
  function initRotators(scope = document) {
    $$('[data-rotator]', scope).forEach((el) => {
      if (el.dataset.rotatorReady) return;
      el.dataset.rotatorReady = '1';
      const items = $$('[data-rotator-item]', el);
      const dots = $$('[data-rotator-dot]', el);
      if (items.length < 2) return;
      const delay = Number(el.dataset.rotator) || 4000;
      let index = 0;
      let timer;
      const show = (next) => {
        items[index].classList.remove('is-active');
        dots[index]?.classList.remove('is-active');
        index = (next + items.length) % items.length;
        items[index].classList.add('is-active');
        dots[index]?.classList.add('is-active');
      };
      const start = () => { clearInterval(timer); timer = setInterval(() => show(index + 1), delay); };
      dots.forEach((dot, n) => dot.addEventListener('click', () => { show(n); start(); }));
      start();
    });
  }

  /* ---------- Avis défilants ---------- */
  function initMarquees(scope = document) {
    $$('[data-marquee]', scope).forEach((track) => {
      if (track.dataset.marqueeReady) return;
      track.dataset.marqueeReady = '1';
      [...track.children].forEach((item) => {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        track.appendChild(clone);
      });
    });
  }

  /* ---------- Carrousels ---------- */
  function initCarousels(scope = document) {
    $$('[data-carousel]', scope).forEach((el) => {
      const track = $('[data-carousel-track]', el);
      if (!track || track.dataset.carouselReady) return;
      track.dataset.carouselReady = '1';
      const prev = $('[data-carousel-prev]', el);
      const next = $('[data-carousel-next]', el);
      const update = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      };
      const scroll = (dir) => track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: reduceMotion ? 'auto' : 'smooth' });
      prev?.addEventListener('click', () => scroll(-1));
      next?.addEventListener('click', () => scroll(1));
      track.addEventListener('scroll', update, { passive: true });
      addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Apparition au scroll ---------- */
  const io = ('IntersectionObserver' in window && !reduceMotion)
    ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' })
    : null;
  function initReveals(scope = document) {
    $$('.reveal:not(.is-in)', scope).forEach((el) => (io ? io.observe(el) : el.classList.add('is-in')));
  }

  /* ---------- Dialogs (tiroirs + popup) ---------- */
  function openDialog(dialog) {
    if (!dialog || dialog.open) return;
    $$('dialog[open]').forEach((d) => closeDialog(d, true));
    dialog.classList.remove('is-closing');
    dialog.showModal();
    document.documentElement.classList.add('is-locked');
    const target = $('[data-autofocus]', dialog);
    if (target) target.focus({ preventScroll: true });
  }

  function closeDialog(dialog, instant = false) {
    if (!dialog || !dialog.open) return;
    const finish = () => {
      dialog.classList.remove('is-closing');
      dialog.close();
      if (!$('dialog[open]')) document.documentElement.classList.remove('is-locked');
    };
    if (instant || reduceMotion) { finish(); return; }
    dialog.classList.add('is-closing');
    let done = false;
    const once = () => { if (!done) { done = true; finish(); } };
    dialog.addEventListener('animationend', once, { once: true });
    setTimeout(once, 450);
  }

  $$('dialog').forEach((dialog) => {
    dialog.addEventListener('cancel', (e) => { e.preventDefault(); closeDialog(dialog); });
    dialog.addEventListener('click', (e) => {
      if (e.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      const inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      if (!inside) closeDialog(dialog);
    });
  });

  /* ---------- Panier ---------- */
  const cartDrawer = $('#cart-drawer');
  const useDrawer = config.cartType === 'drawer' && cartDrawer;
  const lineList = $('[data-cart-lines]');
  const emptyState = $('[data-cart-empty]');
  const cartFoot = $('[data-cart-foot]');
  const subtotalEl = $('[data-cart-subtotal]');
  const titleCount = $('[data-cart-title-count]');
  const shipText = $('[data-ship-text]');
  const shipFill = $('[data-ship-fill]');

  const api = {
    async cart() {
      const res = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      return res.json();
    },
    async add(formData) {
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || strings.cartError);
      return data;
    },
    async change(key, quantity) {
      const res = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || strings.cartError);
      return data;
    },
  };

  const sizedImage = (url, width) => {
    if (!url) return '';
    try {
      const u = new URL(url, location.origin);
      u.searchParams.set('width', width);
      return u.toString();
    } catch { return url; }
  };

  function renderCart(cart) {
    if (!cart) return;
    currency = cart.currency || currency;
    const count = cart.item_count || 0;

    $$('[data-cart-count]').forEach((el) => { el.textContent = count; });
    if (titleCount) titleCount.textContent = count ? `(${count})` : '';
    if (!lineList) return;

    emptyState.hidden = count > 0;
    lineList.hidden = count === 0;
    cartFoot.hidden = count === 0;

    lineList.innerHTML = (cart.items || []).map((item) => {
      const media = item.image
        ? `<img src="${esc(sizedImage(item.image, 200))}" alt="" width="72" height="96" loading="lazy">`
        : '<svg viewBox="0 0 240 480" aria-hidden="true"><use href="#case"/></svg>';
      const variant = item.product_has_only_default_variant ? '' : `<p class="line__meta">${esc(item.variant_title)}</p>`;
      return `
        <li class="line">
          <a class="line__media" href="${esc(item.url)}" tabindex="-1" aria-hidden="true">${media}</a>
          <div>
            <p class="line__name"><a href="${esc(item.url)}">${esc(item.product_title)}</a></p>
            ${variant}
            <div class="qty">
              <button type="button" data-line-qty="${item.quantity - 1}" data-key="${esc(item.key)}" aria-label="${esc(strings.decrease)}">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-line-qty="${item.quantity + 1}" data-key="${esc(item.key)}" aria-label="${esc(strings.increase)}">+</button>
            </div>
          </div>
          <div class="line__end">
            <p class="line__price">${money(item.final_line_price)}</p>
            <button class="line__remove" type="button" data-line-qty="0" data-key="${esc(item.key)}">${esc(strings.remove)}</button>
          </div>
        </li>`;
    }).join('');

    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

    const threshold = Number(config.freeShipping) || 0;
    if (shipText && shipFill && threshold > 0) {
      const rate = Number(window.Shopify?.currency?.rate) || 1;
      const thresholdCents = Math.round(threshold * rate * 100);
      const left = thresholdCents - cart.total_price;
      shipText.textContent = left > 0
        ? (strings.freeShippingLeft || '').replace('[amount]', money(left))
        : strings.freeShippingDone;
      shipFill.style.width = `${Math.min(100, (cart.total_price / thresholdCents) * 100)}%`;
    }
  }

  function bumpCart() {
    const btn = $('.cart-btn');
    if (!btn || reduceMotion) return;
    btn.classList.remove('is-bump');
    void btn.offsetWidth;
    btn.classList.add('is-bump');
  }

  try { renderCart(JSON.parse($('#cart-state')?.textContent || 'null')); } catch { /* état initial absent */ }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form || !useDrawer) return;
    e.preventDefault();
    const button = $('[type="submit"]', form);
    button?.setAttribute('aria-busy', 'true');
    if (button) button.disabled = true;
    try {
      await api.add(new FormData(form));
      renderCart(await api.cart());
      bumpCart();
      openDialog(cartDrawer);
    } catch (err) {
      showToast(err.message);
    } finally {
      button?.removeAttribute('aria-busy');
      if (button && !button.dataset.soldOut) button.disabled = false;
    }
  });

  /* ---------- Clics délégués ---------- */
  document.addEventListener('click', async (e) => {
    const target = e.target;

    const opener = target.closest('[data-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.open);
      if (dialog && (dialog !== cartDrawer || useDrawer)) {
        e.preventDefault();
        openDialog(dialog);
        return;
      }
    }

    const closer = target.closest('[data-close]');
    if (closer) { closeDialog(closer.closest('dialog')); return; }

    const lineQty = target.closest('[data-line-qty]');
    if (lineQty) {
      lineQty.disabled = true;
      try { renderCart(await api.change(lineQty.dataset.key, Number(lineQty.dataset.lineQty))); }
      catch (err) { showToast(err.message); lineQty.disabled = false; }
      return;
    }

    if (target.closest('[data-placeholder]')) { showToast(strings.placeholder); return; }

    const more = target.closest('[data-reviews-more]');
    if (more) {
      $$('[data-review-extra]', more.closest('section')).forEach((r) => { r.hidden = false; });
      more.hidden = true;
      return;
    }

    const step = target.closest('[data-step]');
    if (step) {
      const input = $('input', step.closest('[data-qty-stepper]'));
      if (input) input.value = Math.max(1, (Number(input.value) || 1) + Number(step.dataset.step));
    }
  });

  /* ---------- Sélecteur de variantes ---------- */
  $$('[data-variant-picker]').forEach((picker) => {
    let variants = [];
    try { variants = JSON.parse($('[data-variants]', picker).textContent); } catch { return; }
    const form = document.getElementById(picker.dataset.formId);
    if (!form) return;
    const idInput = $('[data-variant-id]', form);
    const addButton = $('[data-add-button]', form);
    const section = picker.closest('[data-product-section]');
    const priceEl = $('[data-product-price] [data-price]', section);

    picker.addEventListener('change', () => {
      const selected = $$('fieldset', picker).map((fs) => $('input:checked', fs)?.value);
      $$('[data-option-label]', picker).forEach((label, i) => { label.textContent = selected[i] || ''; });
      const variant = variants.find((v) => v.options.every((opt, i) => opt === selected[i]));

      if (!variant) {
        addButton.disabled = true;
        addButton.dataset.soldOut = '1';
        addButton.textContent = strings.unavailable;
        return;
      }

      idInput.value = variant.id;
      addButton.disabled = !variant.available;
      if (variant.available) delete addButton.dataset.soldOut; else addButton.dataset.soldOut = '1';
      addButton.textContent = variant.available ? strings.addToCart : strings.soldOut;

      if (priceEl) {
        const compare = variant.compare_at_price > variant.price
          ? ` <s class="price__compare">${money(variant.compare_at_price)}</s>` : '';
        priceEl.innerHTML = `<span class="price__current">${money(variant.price)}</span>${compare}`;
      }

      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState(null, '', url);

      const mediaId = variant.featured_media?.id;
      const media = mediaId && $(`[data-media-id="${mediaId}"]`, section);
      if (media) {
        const gallery = media.closest('[data-gallery]');
        if (gallery.scrollWidth > gallery.clientWidth) {
          gallery.scrollTo({ left: media.offsetLeft - gallery.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
        } else {
          media.scrollIntoView({ block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      }
    });
  });

  /* ---------- Tri des collections ---------- */
  $$('[data-sort-form] select').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      location.href = url.toString();
    });
  });

  /* ---------- Popup e-mail ---------- */
  const POPUP_KEY = 'kokkz-popup-seen';
  const popup = $('[data-popup]');
  if (popup) {
    if ($('[data-popup-success]', popup)) {
      openDialog(popup);
    } else if (popup.dataset.popupEnabled === 'true' && !store.get(POPUP_KEY, false) && !window.Shopify?.designMode) {
      setTimeout(() => {
        if ($('dialog[open]')) return;
        openDialog(popup);
        store.set(POPUP_KEY, true);
      }, (Number(popup.dataset.popupDelay) || 0) * 1000);
    }
  }

  /* ---------- Vidéos d'ambiance : lecture seulement quand elles sont visibles ---------- */
  function initVideos(scope = document) {
    $$('video[data-autoplay-video]', scope).forEach((video) => {
      if (video.dataset.videoReady) return;
      video.dataset.videoReady = '1';
      if (reduceMotion) {
        video.removeAttribute('autoplay');
        video.pause();
        return;
      }
      if (!('IntersectionObserver' in window)) return;
      new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) video.play().catch(() => {});
        else video.pause();
      }, { threshold: 0.1 }).observe(video);
    });
  }

  /* ---------- Éditeur de thème ---------- */
  function initAll(scope = document) {
    initRotators(scope);
    initMarquees(scope);
    initCarousels(scope);
    initReveals(scope);
    initVideos(scope);
  }
  initAll();

  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (e) => initAll(e.target));
    document.addEventListener('shopify:section:select', (e) => {
      const dialog = $('dialog', e.target);
      if (dialog && dialog.id === 'newsletter-popup') openDialog(dialog);
    });
    document.addEventListener('shopify:section:deselect', (e) => {
      const dialog = $('dialog[open]', e.target);
      if (dialog) closeDialog(dialog, true);
    });
  }
})();
